import { 
  COMMENTS_CREATE_MUTATION, 
  COMMENTS_DELETE_MUTATION, 
  COMMENTS_UPDATE_MUTATION 
} from '@graphql'

import { useMutation } from '@apollo/client'

const useSaveTeacherComments = () => {
  const [createComment, createCommentState] = useMutation(COMMENTS_CREATE_MUTATION)
  const [deleteComment, deleteCommentState] = useMutation(COMMENTS_DELETE_MUTATION)
  const [updateComment, updateCommentState] = useMutation(COMMENTS_UPDATE_MUTATION)

  const isSaving = createCommentState.loading || deleteCommentState.loading || updateCommentState.loading || false
  const error = createCommentState.error || deleteCommentState.error || updateCommentState.error || null

  const getMode = (oldComment, newComment) => {
    if (newComment === null) {
      newComment = ""
    }
    
    if (oldComment === null) {
      oldComment = ""
    }

    newComment = newComment.trim()
    
    if (!oldComment && newComment.length > 0) return "new"
    if (oldComment && !newComment) return "delete"
    if (oldComment && newComment && oldComment !== newComment) return "edit"

    return "unchanged"
  }

  const handleSave = (eventId, comment, mode, bookingSlotId, id = null) => {
    if (mode === "new") {
      return createComment({ 
        variables: { 
          input: { 
            comment, 
            commentable_id: bookingSlotId,
            commentable_type: "App\\BookingSlot", 
            event_id: eventId,
            private: true
          } 
        } 
      }).then((response) => response.data.createComment)
    }

    if (mode === "edit" && id) {
      return updateComment({ variables: { input: { id, comment, private: true } } }).then((response) => response.data.updateComment)
    }

    if (mode === "delete" && id) {
      return deleteComment({ variables: { id } }).then((response) => response.data.deleteComment)
    }
  }

  return { getMode, handleSave, isSaving, error }
}

export default useSaveTeacherComments